import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
// import styles from './Address.module.scss'
import { useSelector } from 'react-redux'
import { getNestedProperty } from '../../helpers/getNestedProperty';
import { StatusInputWrapper } from '../StatusInputWrapper';

const PostalCode = ({ t, reduxAppProperty, changeObjectPropertyAction, validatePostalCode, postalCodeError, postalCodeValid, setIsError }) => {
  // const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const postalCode = useSelector((state) => getNestedProperty(state.app, reduxAppProperty).postalCode)

  const handlePostalCode = (e) => {
    try {
      let name = e.currentTarget.value
      changeObjectPropertyAction('postalCode', name);
      validatePostalCode(name.replace(' ', '').toUpperCase())
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurPostalCode = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.replace(' ', '').toUpperCase();
      changeObjectPropertyAction('postalCode', name);
      validatePostalCode(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <StatusInputWrapper
      isValid={postalCodeValid}
      errorMsg={postalCodeError}
      t={t}
      label={t('current_address.postal_code')}
      id="PostalCode" name="PostalCode" type="text"
      isFocussed={isFocussed}
      aria-describedby="postal-code"
      customClasses={'fw-6'}
      onChange={handlePostalCode}
      onBlur={onBlurPostalCode}
      onFocus={() => SetIsFocussed(true)}
      value={postalCode}
      autoComplete="off"
      maxLength="7"
    />
  )
}

export default withTranslation('common')(PostalCode)